"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createThemePalette = void 0;
var createThemePaletteBasic_1 = require("../createThemePaletteBasic");
var createThemePaletteElevation_1 = require("../createThemePaletteElevation");
var createThemePalette = function (setup) {
    var _a, _b;
    var _c = setup.palette, tonalOffset = _c.tonalOffset, elevationOffset = _c.elevationOffset, otherFeatures = __rest(_c, ["tonalOffset", "elevationOffset"]);
    return Object.freeze(__assign(__assign({}, otherFeatures), { tonalOffset: tonalOffset,
        elevationOffset: elevationOffset, primary: createThemePaletteBasic_1.createThemePaletteBasic(__assign({ main: '#0ff' }, setup.palette.primary), tonalOffset), secondary: createThemePaletteBasic_1.createThemePaletteBasic(__assign({ main: '#ff0' }, setup.palette.secondary), tonalOffset), success: createThemePaletteBasic_1.createThemePaletteBasic(__assign({ main: '#0f0' }, setup.palette.success), tonalOffset), error: createThemePaletteBasic_1.createThemePaletteBasic(__assign({ main: '#f00' }, setup.palette.error), tonalOffset), neutral: createThemePaletteElevation_1.createThemePaletteElevation((_b = (_a = setup.palette.neutral) === null || _a === void 0 ? void 0 : _a.main) !== null && _b !== void 0 ? _b : '#000', elevationOffset) }));
};
exports.createThemePalette = createThemePalette;
